import { useEffect, useState } from "react";
import {
  ProgressRadial,
  Modal,
  LabeledSelect,
  LabeledInput,
  Button,
} from "@itwin/itwinui-react";
import { useSBAutoDeleteUpdater } from "../../hooks/useSBAutoDeleteUpdater/useSBAutoDeleteUpdater";

export const SBAutoDeleteModal = (props: {
  modalIsOpen: boolean;
  setModalIsOpen: (open: boolean) => void;
}) => {
  const { modalIsOpen, setModalIsOpen } = props;
  const [type, setType] = useState("subscription");
  const [topic, setTopic] = useState("");
  const [subscription, setSubscription] = useState("");
  const [queue, setQueue] = useState("");
  const [idleDays, setIdleDays] = useState(0);

  const [data, loading, error, update] = useSBAutoDeleteUpdater();

  useEffect(() => {
    setTopic("");
    setSubscription("");
    setQueue("");
  }, [type]);

  return (
    <Modal
      isOpen={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      closeOnEsc
      isDismissible
      title={`SB Auto Delete On Idle`}
    >
      <div style={{ width: "900px" }}>
        <LabeledSelect
          label="Type"
          options={[
            { value: "subscription", label: "Topic Subscription" },
            { value: "topic", label: "Topic" },
            { value: "queue", label: "Queue" },
          ]}
          value={type}
          onChange={setType}
          style={{ width: "25%", marginBottom: "10px" }}
        />
        {(type === "topic" || type === "subscription") && (
          <div>
            <LabeledInput
              label="Topic"
              value={topic}
              onChange={(event) => {
                setTopic(event.target.value);
              }}
              style={{ width: "50%", marginBottom: "10px" }}
            />
          </div>
        )}
        {type === "subscription" && (
          <div>
            <LabeledInput
              label="Subscription"
              value={subscription}
              onChange={(event) => {
                setSubscription(event.target.value);
              }}
              style={{ width: "50%", marginBottom: "10px" }}
            />
          </div>
        )}
        {type === "queue" && (
          <div>
            <LabeledInput
              label="Queue"
              value={queue}
              onChange={(event) => {
                setQueue(event.target.value);
              }}
              style={{ width: "50%", marginBottom: "10px" }}
            />
          </div>
        )}
        <LabeledSelect
          label="Delete when idle for"
          options={[
            { value: 0, label: "Never (no auto delete)" },
            { value: 14, label: "14 days" },
            { value: 30, label: "30 days" },
            { value: 60, label: "60 days" },
          ]}
          value={idleDays}
          onChange={setIdleDays}
          style={{ width: "25%", marginBottom: "10px" }}
        />
        {data && <div>{JSON.stringify(data, null, 4)}</div>}
        {error && <div>{error.message}</div>}
        <Button
          onClick={() => {
            update(topic, subscription, queue, idleDays);
          }}
        >
          Update Auto Delete
        </Button>
        {loading && (
          <ProgressRadial indeterminate style={{ marginLeft: "20px" }} />
        )}
      </div>
    </Modal>
  );
};
